import { createApp } from 'vue'
import { i18n } from './i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import draggableModal from './composables/draggableModal'
import tooltip from './composables/tooltip.js'
import './assets/styles/main.scss'
import 'bootstrap'
import { validLocale } from '@/composables/formatUtils'
import * as microsoftTeams from '@microsoft/teams-js'

async function initApp () {
  await store.dispatch('initialiseApp')
}

initApp().then(() => {
  let userLocale =
    store.state.loginStatus && store.state.user.settings?.language
      ? store.state.user.settings.language
      : (navigator.language || navigator.userLanguage)
  userLocale = validLocale(userLocale)

  i18n.global.locale.value = userLocale

  createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .directive('draggable-modal', draggableModal)
    .directive('tooltip', tooltip)
    .mount('#app')

  if (window.location.href.includes('context=msteams')) {
    microsoftTeams.app.initialize()
    microsoftTeams.app.getContext((context) => {
      const userId = document.getElementById('user')
      userId.innerHTML = context.userPrincipalName
    })
  }
})
